import styled from 'styled-components';

import { Select as UISelect } from '@/shared/ui/select';

import { Box } from '../box';

export const Select = styled(UISelect)`
	& ul {
		transform-origin: bottom;
		transform: translateY(-100%);
		top: 0;
		white-space: nowrap;
	}
`;

export const SelectWrapper = styled(Box)``;
